import map from 'lodash/map';

export const PLACEHOLDER_VALUE = '_place_';
export const NONE_VALUE = '_none_';

/**
 * @param description
 * @param key
 * @param disabled
 * @returns {{value, label, isDisabled}}
 */
export const generateOption = (description, key, disabled) => ({
  value: key,
  label: description,
  isDisabled: disabled,
});

/**
 * @param {Object} options - An object where keys are option values and values are option descriptions.
 * @param {string} deselectString - A string to be used as the first option, typically for deselecting.
 * @param {boolean} deselectIsDisabled - Whether the deselect option should be disabled.
 * @returns {Array} An array of options formatted for a select box.
 */
export const generateOptsArray = (
  options,
  deselectString,
  deselectIsDisabled,
) => {
  const selectOptions = [];

  if (deselectString) {
    selectOptions.push(
      generateOption(deselectString, NONE_VALUE, deselectIsDisabled),
    );
  }
  map(options, (description, key) =>
    selectOptions.push(generateOption(description, key)),
  );

  return selectOptions;
};
